/**
 * Storage adapter exports and factory for Express
 */

export * from './types';
export { MemoryStorageAdapter } from './memory-adapter';
export { RedisStorageAdapter } from './redis-adapter';

import type { StorageAdapter, StorageConfig } from './types';
import { MemoryStorageAdapter } from './memory-adapter';
import { RedisStorageAdapter } from './redis-adapter';

/**
 * Create a storage adapter based on configuration
 */
export async function createStorageAdapter(config?: StorageConfig): Promise<StorageAdapter> {
  if (!config || config.type === 'memory') {
    return new MemoryStorageAdapter();
  }
  
  if (config.type === 'custom' && config.custom) {
    return config.custom;
  }
  
  if (config.type === 'redis' && config.redis) {
    // Dynamically import Redis client
    try {
      // @ts-ignore - Optional peer dependency
      const { Redis } = await import('@upstash/redis');
      const redis = new Redis({
        url: config.redis.url,
        token: config.redis.token,
      });
      return new RedisStorageAdapter(redis as any, config.ttl);
    } catch (error) {
      console.warn('[AgentShield] Failed to initialize Redis storage, falling back to memory:', error);
      return new MemoryStorageAdapter();
    }
  }
  
  // Default to memory storage
  return new MemoryStorageAdapter();
}